export const categories = [
  {
    slug: 'caodi-jingji',
    name: '草地竞技',
    description: '在专业草地球场上进行的各类竞技比赛，考验选手的速度、力量和技巧。',
    icon: 'ri-basketball-line',
    articleCount: 28,
    image: 'https://readdy.ai/api/search-image?query=Professional%20grass%20sports%20field%20with%20athletes%20competing%20on%20natural%20green%20turf%2C%20dynamic%20action%20shot%2C%20sporting%20event%20atmosphere%2C%20bright%20natural%20daylight%2C%20clean%20minimal%20background%20with%20soft%20bokeh%2C%20editorial%20sports%20photography%2C%20vibrant%20green%20tone&width=800&height=500&seq=cat-caodi-01&orientation=landscape',
  },
  {
    slug: 'caoyuan-saidai',
    name: '草园赛道',
    description: '模拟草原环境的障碍赛道，融合耐力与策略，挑战选手的极限表现。',
    icon: 'ri-riding-line',
    articleCount: 22,
    image: 'https://readdy.ai/api/search-image?query=Grassland%20obstacle%20course%20with%20athletes%20racing%20through%20natural%20meadow%20terrain%2C%20golden%20hour%20sunlight%2C%20competitive%20sports%20event%2C%20wide%20open%20fields%20with%20rolling%20hills%2C%20clean%20composition%2C%20editorial%20photography&width=800&height=500&seq=cat-caoyuan-01&orientation=landscape',
  },
  {
    slug: 'ludi-taofa',
    name: '绿地挑战',
    description: '城市绿地中的趣味竞技项目，适合所有年龄段参与，轻松有趣又不失竞技感。',
    icon: 'ri-heart-pulse-line',
    articleCount: 19,
    image: 'https://readdy.ai/api/search-image?query=Urban%20park%20green%20space%20with%20people%20participating%20in%20fun%20outdoor%20sports%20activities%2C%20community%20fitness%20event%2C%20bright%20sunny%20day%2C%20lush%20green%20grass%20and%20trees%2C%20joyful%20atmosphere%2C%20clean%20editorial%20style&width=800&height=500&seq=cat-ludi-01&orientation=landscape',
  },
  {
    slug: 'zonghe-saishi',
    name: '综合赛事',
    description: '汇集多种草类竞技项目的综合型赛事，全方位展示竞技实力与多样化技巧。',
    icon: 'ri-trophy-line',
    articleCount: 35,
    image: 'https://readdy.ai/api/search-image?query=Multi%20sport%20grass%20arena%20competition%20event%20with%20various%20athletic%20disciplines%2C%20large%20stadium%20setting%20with%20green%20field%2C%20crowd%20cheering%2C%20trophy%20ceremony%20atmosphere%2C%20professional%20sports%20photography%2C%20bright%20daylight&width=800&height=500&seq=cat-zonghe-01&orientation=landscape',
  },
  {
    slug: 'xinren-rumen',
    name: '新人入门',
    description: '为零基础玩家准备的入门指南和基础训练课程，快速上手草类竞技。',
    icon: 'ri-user-star-line',
    articleCount: 16,
    image: 'https://readdy.ai/api/search-image?query=Beginner%20sports%20training%20session%20on%20green%20grass%20field%20with%20coach%20instructing%20new%20athletes%2C%20friendly%20learning%20environment%2C%20sunny%20outdoor%20setting%2C%20supportive%20atmosphere%2C%20clean%20minimal%20composition&width=800&height=500&seq=cat-xinren-01&orientation=landscape',
  },
  {
    slug: 'gaoji-jijie',
    name: '高级技巧',
    description: '深度解析草类竞技高级技巧与战术策略，帮助资深玩家突破瓶颈。',
    icon: 'ri-flashlight-line',
    articleCount: 14,
    image: 'https://readdy.ai/api/search-image?query=Elite%20athlete%20demonstrating%20advanced%20techniques%20on%20professional%20grass%20sports%20field%2C%20dynamic%20motion%20capture%2C%20dramatic%20lighting%2C%20competitive%20sports%20photography%2C%20clean%20green%20background%2C%20powerful%20action&width=800&height=500&seq=cat-gaoji-01&orientation=landscape',
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || null;
};